import { FILTER_MESSAGES, FiltersMessages } from "../inputs/filters.messages";

export type ImportationDetailsFiltersMessages = FiltersMessages & {
  dateOption: string;
  codeOption: string;
  nameOption: string;
  statusOption: string;
  messageOption: string;
  allOption: string;
  contactOption: string;
  productOption: string;
  pendingOption: string;
  processingOption: string;
  completedOption: string;
  createdOption: string;
  updatedOption: string;
  warningOption: string;
  errorOption: string;
  selectStatusPlaceholder: string;
};

export const IMPORTATION_DETAILS_FILTER_MESSAGES: ImportationDetailsFiltersMessages = {
  ...FILTER_MESSAGES,
  dateOption: "Data",
  codeOption: "Código",
  nameOption: "Nome",
  statusOption: "Status",
  messageOption: "Mensagem",
  allOption: "Todos",
  contactOption: "Contato",
  productOption: "Produto",
  pendingOption: "Pendente",
  processingOption: "Processando",
  completedOption: "Concluído",
  createdOption: "Criado",
  updatedOption: "Atualizado",
  warningOption: "Aviso",
  errorOption: "Erro",
  selectStatusPlaceholder: "Selecionar status",
};

export default IMPORTATION_DETAILS_FILTER_MESSAGES;